import React from "react";

/*
  SidebarToggleIcon
  - Custom hamburger-like toggle with a directional triangle on the middle bar
  - Props:
    - toggled: boolean (true = expanded/open, triangle on left pointing left)
    - onToggle: function
    - size: number (pixel size of icon square)
    - color: string (stroke/fill color)
*/
export default function SidebarToggleIcon({
  toggled = false,
  onToggle,
  size = 26,
  color = "#6c757d",
  title,
}) {
  const w = 48; // viewBox width/height
  const h = 48;
  const stroke = color;
  const barH = 4;
  const fullW = 32; // full bar width
  const midW = 22;  // shorter middle bar
  const cx = w / 2;
  const startX = (w - fullW) / 2; // x start for full-width bars
  const yTop = 14;
  const yMid = 24;
  const yBot = 34;

  // Middle bar aligns based on toggle state
  const midStartX = toggled
    ? startX + (fullW - midW) // align right
    : startX;                // align left

  // Triangle properties
  const triSize = 6;
  const triOffset = 3;
  const triProps = toggled
    ? {
        // expanded: triangle on left, pointing left
        points: `${midStartX - triOffset},${yMid} ${midStartX - triOffset - triSize},${yMid - triSize} ${midStartX - triOffset - triSize},${yMid + triSize}`,
      }
    : {
        // collapsed: triangle on right, pointing right
        points: `${midStartX + midW + triOffset},${yMid} ${midStartX + midW + triOffset + triSize},${yMid - triSize} ${midStartX + midW + triOffset + triSize},${yMid + triSize}`,
      };

  return (
    <button
      type="button"
      onClick={onToggle}
      title={title || (toggled ? "Collapse sidebar" : "Expand sidebar")}
      aria-label={title || (toggled ? "Collapse sidebar" : "Expand sidebar")}
      style={{
        appearance: 'none',
        border: 'none',
        background: 'transparent',
        padding: 0,
        lineHeight: 0,
        cursor: 'pointer',
      }}
    >
      <svg
        width={size}
        height={size}
        viewBox={`0 0 ${w} ${h}`}
        role="img"
        aria-hidden={false}
        style={{ display: 'block' }}
      >
        {/* Top bar */}
        <rect
          x={startX}
          y={yTop - barH / 2}
          width={fullW}
          height={barH}
          rx={barH / 2}
          fill={stroke}
          style={{ transition: 'transform 200ms ease, opacity 200ms ease' }}
        />

        {/* Middle shorter bar */}
        <rect
          x={midStartX}
          y={yMid - barH / 2}
          width={midW}
          height={barH}
          rx={barH / 2}
          fill={stroke}
          style={{ transition: 'transform 200ms ease, opacity 200ms ease' }}
        />

        {/* Bottom bar */}
        <rect
          x={startX}
          y={yBot - barH / 2}
          width={fullW}
          height={barH}
          rx={barH / 2}
          fill={stroke}
          style={{ transition: 'transform 200ms ease, opacity 200ms ease' }}
        />

        {/* Directional triangle */}
        <polygon
          points={triProps.points}
          fill={stroke}
          style={{ transition: 'all 200ms ease' }}
        />
      </svg>
    </button>
  );
}
